// extracted by mini-css-extract-plugin
module.exports = {"productInfo":"salesTableColumns_productInfo__2nNaa","productImage":"salesTableColumns_productImage__2QXKL","productName":"salesTableColumns_productName__3ozDc"};